import React from "react";
import Helmet from "react-helmet";
import favicon from "../../../assets/logofavcon@2x.png";
import { PostBody } from "../../components/Post";
import { H3, H5 } from "../../components/typography";

import ReactMarkdown from "react-markdown";
import NavBar from "../../components/NavBar";
import Section from "../../components/blocks/Section";
import Pad from "../../components/blocks/Pad";
import Spacer from "../../components/blocks/Spacer";
import Background from "../../components/blocks/Background";
import { MetaTags } from "../../components/atoms/SocialTags";

const ListingBody = PostBody.extend`padding: 0;`;

const Label = H5.extend`
  padding-top: 2.5rem;
  padding-bottom: .625rem;
  font-weight: 500;
`;

export default props => {
  const jobListing = props.pathContext;

  return (
    <div>
      <Helmet
        title="Contraline News"
        meta={[{ name: "Contraline", content: jobListing.title }]}
      >
        <link rel="icon" type="image/png" href={favicon} />
        <MetaTags
          title={jobListing.title}
          description={
            jobListing.description && jobListing.description.description
          }
        />
      </Helmet>
      <NavBar color="dark" background="white" />
      <Background color="white" fixed={true}>
        <Section noBorder fixed={true} vPad={false}>
          <Pad h={2} v={2}>
            <Label>Position</Label>
            <H3 serif>
              {jobListing.title}
            </H3>
            <Label>About Contraline</Label>
            <ListingBody style={{ paddingLeft: 0 }}>
              <ReactMarkdown
                source={
                  jobListing.aboutContraline &&
                  jobListing.aboutContraline.aboutContraline
                }
              />
            </ListingBody>
            <Label>Job description</Label>
            <ListingBody style={{ paddingLeft: 0 }}>
              <ReactMarkdown
                source={
                  jobListing.description && jobListing.description.description
                }
              />
            </ListingBody>
            <Label>What you'll do</Label>
            <ListingBody style={{ paddingLeft: 0 }}>
              <ReactMarkdown
                source={
                  jobListing.responsibilities &&
                  jobListing.responsibilities.responsibilities
                }
              />
            </ListingBody>
            <Label>What you'll need</Label>
            <ListingBody style={{ paddingLeft: 0 }}>
              <ReactMarkdown
                source={jobListing.criteria && jobListing.criteria.criteria}
              />
            </ListingBody>
          </Pad>
          <Spacer span={2} />
        </Section>
      </Background>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/pages/careers/post.js